export default __webpack_public_path__ + "static/131-min-min-bc0bf241814eca0916098cbca6f5c08d.jpg";